import $ from 'jquery';

/**
 * If 'Please Select' is selected in dropdowns, grey this option out.
 */
class DropdownSelectChange {
    constructor() {
        this.$dropdowns = $('.js-select-dropdown');

        this.$dropdowns.on('change', () => {
            this.dropdownChange();
        });

        $(window).on('load', $.proxy(this.onLoad, this));
    }

    dropdownChange() {
        this.$dropdowns.each((index, dropdown) => {
            const $dropdown = $(dropdown);
            const selectedText = $dropdown.find("option:selected").text();

            if (selectedText.toLowerCase().indexOf('please select') > -1) {
                $dropdown.addClass('o-form__dropdown--greyed-out'); // Add a class to gray out the select
            } else {
                $dropdown.removeClass('o-form__dropdown--greyed-out'); // Remove the grayed-out class
            }
        });
    }

    onLoad() {
        this.dropdownChange();
    }
}

export default DropdownSelectChange;
